import { useEffect } from 'react'
import { fontType } from '../assets/extras'

const NotFound = () => {

    const containerStyle = {
        margin: 0,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f9f9f9",
    };

    const errorStyle = {
        fontSize: "120px",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
    };

    const tennisBallStyle = {
        width: "100px",
        height: "100px",
        animation: "bounce 0.6s infinite ease-in-out",
    };

    const messageStyle = {
        marginTop: "20px",
        fontSize: "24px",
        color: "#555",
    };

    useEffect(() => {
        document.title = "Page Not Found"
    }, [])

    return (
        <div style={containerStyle}>
            <div style={errorStyle}>
                4
                {/* Pelota de tennis en SVG */}
                <svg
                    style={tennisBallStyle}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                >
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="#c6e600"
                        stroke="white"
                        strokeWidth="4"
                    />
                    <path
                        d="M25 15 Q15 50 25 85"
                        stroke="white"
                        strokeWidth="4"
                        fill="none"
                    />
                    <path
                        d="M75 15 Q85 50 75 85"
                        stroke="white"
                        strokeWidth="4"
                        fill="none"
                    />
                </svg>
                4
            </div>
            <div style={messageStyle}>Page Not Found</div>

            {/* Animación como etiqueta <style> */}
            <style>
                {`
                    @keyframes bounce {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(25px); }
                    }
                `}
            </style>
        </div>
    )
}

export default NotFound